import { HttpEvent, HttpEventType, HttpProgressEvent } from '@angular/common/http'

export interface AppProgressbarState {
   isLoading?: boolean
   mode: 'determinate' | 'indeterminate'
   percentage: number
   status: 'progress' | 'complete' | 'error'
}

export const appProgressbarStart = (): AppProgressbarState => ({
   isLoading: true,
   mode: 'indeterminate',
   percentage: 0,
   status: 'progress'
})

export const appProgressbarUpdate = (state: AppProgressbarState, response: HttpEvent<Blob>): AppProgressbarState => {
   if (response.type === HttpEventType.DownloadProgress || response.type === HttpEventType.UploadProgress) {
      const progress = response as HttpProgressEvent

      if (progress.total) {
         return {
            ...state,
            mode: 'determinate',
            percentage: Math.min(100, Math.round((100 * progress.loaded) / progress.total))
         }
      }

      return { ...state, mode: 'indeterminate' }
   }

   if (response.type === HttpEventType.Response) {
      return {
         ...state,
         isLoading: true,
         mode: 'determinate',
         percentage: 100,
         status: 'complete'
      }
   }

   return state
}

export const appProgressbarClose = (status: 'complete' | 'error'): AppProgressbarState => ({
   isLoading: undefined,
   mode: 'determinate',
   percentage: status === 'complete' ? 100 : 0,
   status
})
